import { Component } from '@angular/core';

@Component({
    selector: 'kui-dropdown-button',
    templateUrl: './dropdown-button.component.html',
    standalone: false
})
export class KuiDropdownButtonComponent { }


